<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" @click.self="$emit('close')">
    <div class="bg-white rounded-lg p-6 max-w-md w-full">
      <div class="flex justify-between items-start mb-4">
        <h2 class="text-xl font-bold">Quick Call</h2>
        <button @click="$emit('close')" class="text-gray-500 hover:text-gray-700">
          <XMarkIcon class="w-6 h-6" />
        </button>
      </div>
      
      <div v-if="profile" class="space-y-4">
        <div class="text-center">
          <div class="text-4xl mb-2">{{ profile.avatar || 'Y' }}</div>
          <h3 class="font-semibold text-lg">{{ profile.name }}</h3>
          <p class="text-gray-500">{{ profile.phone }}</p>
        </div>
        
        <div class="flex justify-end space-x-2">
          <button @click="$emit('close')" class="btn btn-secondary">Cancel</button>
          <button @click="initiateCall" class="btn btn-primary">
            <PhoneIcon class="w-5 h-5 mr-2" />
            Start Call
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { XMarkIcon, PhoneIcon } from '@heroicons/vue/24/outline'

const props = defineProps({
  profile: {
    type: Object,
    required: true
  }
})

const emit = defineEmits(['close', 'call'])

function initiateCall() {
  emit('call', props.profile)
  emit('close')
}
</script>
